import React, { useEffect } from "react";
import { Form, Input, Modal } from "antd";

import type {
  SaleResponse as LineBotUserRole,
  SaleFormValues as LineBotUserRoleFormValues,
} from "../model/types";

interface Props {
  open: boolean;
  loading?: boolean;
  readOnly?: boolean;
  initialValues?: Partial<LineBotUserRole>;
  onCancel: () => void;
  onSubmit: (values: LineBotUserRoleFormValues) => void;
}

export default function SaleForm({
  open,
  loading = false,
  readOnly = false,
  initialValues,
  onCancel,
  onSubmit,
}: Props) {
  const [form] = Form.useForm();

  useEffect(() => {
    if (!open) return;

    form.resetFields();
    form.setFieldsValue({
      line_id: initialValues?.line_id,
      display_name: initialValues?.display_name,
      email: initialValues?.email,
      // phone_number: initialValues?.phone_number,
    });
  }, [form, initialValues, open]);

  const handleFinish = (values: LineBotUserRoleFormValues) => {
    onSubmit(values);
  };

  return (
    <Modal
      open={open}
      destroyOnHidden
      width={700}
      centered
      title={
        readOnly
          ? "担当者詳細"
          : initialValues?.line_id
            ? "担当者編集"
            : "担当者登録"
      }
      okText={readOnly ? "閉じる" : "保存"}
      cancelText="キャンセル"
      confirmLoading={loading}
      onCancel={onCancel}
      onOk={() => {
        if (readOnly) {
          onCancel();
          return;
        }

        form.submit();
      }}
    >
      <Form form={form} layout="vertical" onFinish={handleFinish}>
        <Form.Item
          label="LINEユーザーID"
          name="line_id"
          rules={[
            {
              required: true,
              message: "LINEユーザーIDを入力してください",
            },
          ]}
        >
          <Input
            disabled={readOnly || !!initialValues?.line_id}
            placeholder="LINEユーザーID"
          />
        </Form.Item>

        <Form.Item
          label="名前"
          name="display_name"
          rules={[
            {
              required: true,
              message: "名前を入力してください",
            },
          ]}
        >
          <Input disabled={readOnly} placeholder="名前" />
        </Form.Item>

        <Form.Item
          label="メールアドレス"
          name="email"
          rules={[
            {
              required: true,
              message: "メールアドレスを入力してください",
            },
            {
              type: "email",
              message: "メールアドレスの形式が正しくありません",
            },
          ]}
        >
          <Input disabled={readOnly} placeholder="メールアドレス" />
        </Form.Item>

        {/* <Form.Item label="電話番号" name="phone_number">
          <Input disabled={readOnly} placeholder="電話番号" />
        </Form.Item> */}
      </Form>
    </Modal>
  );
}
